import { Link, useLocation, useNavigate } from "react-router-dom";
import { NAV_LINKS, COMPANY, BRANDS } from "../data";
import { BrandStacked } from "./Brand";

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 400);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer className="bg-[#111] border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 pb-16">
          <div>
            <BrandStacked
              align="start"
              emblem="w-20 h-20"
              color="#F8F7F3"
              tagColor="#B08D57"
            />
          </div>

          <div>
            <p className="overline text-white/40 mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button onClick={() => go(l.id)} className="font-body text-[#F8F7F3]/80 hover:text-[#B08D57] transition-colors duration-300">
                    {l.label}
                  </button>
                </li>
              ))}
              <li>
                <Link to="/founder" className="font-body text-[#F8F7F3]/80 hover:text-[#B08D57] transition-colors duration-300">
                  Founder's Vision
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="overline text-white/40 mb-6">Our Brands</p>
            <ul className="space-y-3">
              {BRANDS.map((b) => (
                <li key={b.key}>
                  <Link to={`/brands/${b.key}`} className="font-body text-[#F8F7F3]/80 hover:text-[#B08D57] transition-colors duration-300">
                    {b.name.charAt(0) + b.name.slice(1).toLowerCase()}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div data-testid="footer-address">
            <p className="overline text-white/40 mb-6">Registered Office</p>
            <address className="not-italic font-body text-sm text-[#F8F7F3]/70 leading-relaxed">
              <span className="block text-[#F8F7F3]/90 font-head font-semibold mb-2">{COMPANY.legalName}</span>
              {COMPANY.addressLines.map((line) => (
                <span key={line} className="block">{line}</span>
              ))}
            </address>
          </div>

          <div>
            <p className="overline text-white/40 mb-6">Connect</p>
            <a href={`mailto:${COMPANY.email}`} className="block font-body text-[#F8F7F3]/80 hover:text-[#B08D57] transition-colors mb-2">
              {COMPANY.email}
            </a>
            <a href={`http://${COMPANY.website}`} className="block font-body text-[#F8F7F3]/80 hover:text-[#B08D57] transition-colors mb-5">
              {COMPANY.website}
            </a>
            <a
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-2 rounded-full bg-[#B08D57] text-white font-head font-semibold text-sm px-5 py-2.5 mb-5 hover:bg-[#987748] transition-colors"
            >
              WhatsApp Enquiry
            </a>
            <div className="flex gap-5">
              <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer" className="font-body text-sm text-[#F8F7F3]/60 hover:text-[#B08D57] transition-colors link-underline">
                LinkedIn
              </a>
              <a href="#" className="font-body text-sm text-[#F8F7F3]/60 hover:text-[#B08D57] transition-colors link-underline">
                Instagram
              </a>
              <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" className="font-body text-sm text-[#F8F7F3]/60 hover:text-[#B08D57] transition-colors link-underline">
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-sm text-white/40">© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</p>
          <p className="font-body text-sm text-white/40">Premium Indian Export House</p>
        </div>
      </div>
    </footer>
  );
}
